import { Button, MessageBar, MessageBarBody, MessageBarTitle, Spinner, Tooltip, makeStyles } from '@fluentui/react-components';
import { ArrowClockwise16Regular } from '@fluentui/react-icons';
import { useMe } from '../auth/MeProvider';
import { ActivityTable } from '../components/ActivityTable';
import { PageHeader } from '../components/PageHeader';
import { useAudit } from '../lib/useAudit';

/** Events per GET /audit page; "Load older" appends the next page. */
export const ACTIVITY_PAGE = 50;

const useStyles = makeStyles({
  page: { display: 'flex', flexDirection: 'column', rowGap: '14px' },
  pager: { display: 'flex', justifyContent: 'center' },
});

function ActivityScreen() {
  const s = useStyles();
  const audit = useAudit(true, ACTIVITY_PAGE);
  return (
    <div className={s.page}>
      <PageHeader
        title="Activity"
        actions={
          <Tooltip content="Refresh" relationship="label">
            <Button
              appearance="outline"
              shape="circular"
              size="small"
              icon={<ArrowClockwise16Regular />}
              onClick={() => void audit.reload()}
            />
          </Tooltip>
        }
      />
      <ActivityTable events={audit.events} loading={audit.loading} error={audit.error} heading={false} />
      {audit.nextBefore && (
        <div className={s.pager}>
          <Button appearance="outline" shape="circular" size="small" disabled={audit.loading} onClick={() => void audit.more()}>
            Load older
          </Button>
        </div>
      )}
    </div>
  );
}

/** The whole audit trail behind Overview's "Full log", newest first. Admin only. */
export function Activity() {
  const { me, loading, error, isAdmin } = useMe();
  return (
    <>
      {loading && <Spinner label="Loading your permissions" />}
      {error && (
        <MessageBar intent="error">
          <MessageBarBody>{error}</MessageBarBody>
        </MessageBar>
      )}
      {me && !isAdmin && (
        <>
          <PageHeader title="Activity" />
          <MessageBar intent="warning">
            <MessageBarBody>
              <MessageBarTitle>Admins only</MessageBarTitle>
              The audit trail is readable by VPN administrators only.
            </MessageBarBody>
          </MessageBar>
        </>
      )}
      {me && isAdmin && <ActivityScreen />}
    </>
  );
}
